module.exports = __webpack_public_path__ + "static/img/5.279683e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/zh/5.png
// module id = Bkgu
// module chunks = 0